// Generated from ContestJudge's `required_filter_groups` — do not edit.

import type {FilterDefinitionMapping} from '../../boot/hooks/useApi'
import type {Iri} from '../Api'

export type ContestJudgeCollectionFilterGroups
  = | {
    readonly contest: Iri
  }

export const contestJudgeCollectionFilterMapping: FilterDefinitionMapping<ContestJudgeCollectionFilterGroups> = {
  contest: 'contest',
}

export type ContestJudgeCollectionSort = never
